// inv/src/pages/solutions/established-businesses/blocks/EstablishedDiscoverSection.jsx
import { useTranslation } from 'react-i18next';
import CTAHover from '../../../../components/ui/CTAHover';
import { CheckCircle2 } from 'lucide-react';

const EstablishedDiscoverSection = ({ bgColor = 'bg-white' }) => {
  const { t } = useTranslation();

  return (
    <section className={`py-16 sm:py-24 ${bgColor}`}>
      <div className="w-[75%] mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <h3 className="text-2xl text-blue-600 font-bold mb-4">
            {t(
              'pageSolutions.EstablishedBusinesses.t3',
              'Crino for established businesses'
            )}
          </h3>
          <h2 className="text-3xl sm:text-4xl font-semibold text-stone-900">
            {t(
              'pageSolutions.EstablishedBusinesses.t4',
              'Map capital partners for your next stage of growth'
            )}
          </h2>

          <p className="mt-6 text-base leading-7 text-stone-700">
            {t(
              'pageSolutions.EstablishedBusinesses.t5',
              'You already have a proven business. Crino helps you find investors who specialise in scaling established companies — for expansion, acquisitions, capex or partial exits.'
            )}
          </p>

          <ul className="mt-6 space-y-4 text-base leading-7 text-stone-700">
            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t6',
                  'Filter investors by revenue range, cheque size, ownership preference and sector focus.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t7',
                  'See which mature companies they backed recently and in what context — growth, recapitalisation or buyout.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t8',
                  'Build targeted shortlists for expansion, M&A or founder liquidity instead of broad “spray and pray” outreach.'
                )}
              </span>
            </li>

            <li className="flex items-start gap-3">
              <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
                <CheckCircle2 className="h-4 w-4 text-blue-600" />
              </span>
              <span>
                {t(
                  'pageSolutions.EstablishedBusinesses.t9',
                  'Spot strategic and corporate investors already active in your value chain or customer segments.'
                )}
              </span>
            </li>
          </ul>

          <CTAHover
            className="mt-8"
            text={t(
              'pageSolutions.EstablishedBusinesses.t10',
              'Explore capital options for your business'
            )}
            href="pricing/"
            align="left"
            bgColor="bg-blue-600 text-white"
            textColor="text-stone-800"
            hoverTextColor="text-white"
          />
        </div>

        <div className="mt-12 lg:mt-0 grid grid-cols-1 gap-4">
          <img
            className="w-full"
            src="https://crino-cdn.nyc3.cdn.digitaloceanspaces.com/pages-images/solutions/find-capital-partner-for-established-business.png"
            alt={t(
              'pageSolutions.EstablishedBusinesses.alt1',
              'Investor mapping tools for established businesses'
            )}
          />
        </div>
      </div>
    </section>
  );
};

export default EstablishedDiscoverSection;
